const invertedMessages = {
  Close: 'CloseLabel',
  'Please try again.': 'certs.please.try.again',
};

export default invertedMessages;
